import React, { useState } from 'react';
import styles from '../style.module.less';
import {
  SectionContainer as Section,
  ModalContent,
} from 'src/components/Layouts';
import { ModalFooter, Checkbox, Radio, Form } from 'src/components/Antd';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, handleOnGetCurrentSCTimezoneUTC } from 'src/tools/tools';
import DatePickerRangePickerList from '@/src/pages/Settings/Logistics/PickupLocations/Components/DatePickerRangePickerList';
import PickUpTime from '@/src/pages/Settings/Logistics/PickupLocations/Components/PickUpTime';
import { DeliveryOptionType } from '../type';

const DeliveryOptions = (props: any) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { onCancel, type, value, onChange } = props;
  const [_type, setType] = useState(type);
  const [form] = Form.useForm();
  const scTimezoneUTC = handleOnGetCurrentSCTimezoneUTC();

  React.useEffect(() => {
    form.setFieldsValue(value);
  }, []);

  return (
    <Form
      form={form}
      onFinishFailed={() => {
        return;
      }}
      onFinish={() => {
        onChange({ ...form.getFieldsValue(), type: _type });
      }}>
      <ModalContent style={{ paddingTop: 0 }}>
        <Section style={{ paddingTop: 0 }}>
          <div className={styles.deliveryOptionContainer}>
            <Radio
              radioList={[
                {
                  value: DeliveryOptionType.All,
                  label: getI18n('salesChannelLogistics.index.alwayson'),
                },
                {
                  value: DeliveryOptionType.Customize,
                  label: `${getI18n(
                    'salesChannelLogistics.index.scheduledTime',
                  )} (UTC ${scTimezoneUTC})`,
                },
              ]}
              value={_type}
              onChange={(e) => {
                setType(e?.target?.value);
              }}
            />

            <Form.Item noStyle shouldUpdate={(p, c) => p.type !== c.type}>
              {_type === DeliveryOptionType.Customize && <PickUpTime />}
            </Form.Item>
          </div>
          <div className={styles.setDefault}>
            {_type === DeliveryOptionType.Customize && (
              <Form.Item
                name={'blockService'}
                className={styles.checkbox}
                labelAlign='left'
                initialValue={false}
                valuePropName='checked'>
                <Checkbox>
                  <span className={styles.checkboxText}>
                    {getI18n('salesChannelLogistics.index.unavailableInfo')}
                  </span>
                </Checkbox>
              </Form.Item>
            )}
            <Form.Item
              className={styles.specificDateItem}
              shouldUpdate={(p, c) => p.blockService !== c.blockService}>
              {({ getFieldValue }) => {
                const checked = getFieldValue('blockService');

                return (
                  _type === DeliveryOptionType.Customize &&
                  checked && (
                    <Form.Item name={'blockOutDates'}>
                      <DatePickerRangePickerList
                        firstColumName={getI18n(
                          'salesChannelLogistics.index.unavailabledate',
                        )}
                        width={405}
                      />
                    </Form.Item>
                  )
                );
              }}
            </Form.Item>
          </div>
        </Section>
      </ModalContent>
      <ModalFooter
        onCancel={onCancel}
        onOk={() => {
          form.submit();
        }}
      />
    </Form>
  );
};
export default DeliveryOptions;
